<template>
  <a-card :title="!edit ? 'Create Sponsor Config' : 'Edit Sponsor Config'">
    <a-row :loading="preload">
      <a-col>
        <a-form-model ref="formSponsorConfig"
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 12 }"
          :model="form">
          <a-form-model-item label="Sponsor">
            <sponsor-select @change="onSponsorChange" :value="edit ? sponsor_config.hash : ''">
            </sponsor-select>
          </a-form-model-item>

          <a-form-model-item label="Disbursement Account">
            <biller-account-select @change="onBillerAccountChange" :value="edit ? sponsor_config.biller_disbursement_account_id : ''">
            </biller-account-select>
          </a-form-model-item>

          <a-form-model-item label="Sponsor Account" ref="sponsor_account">
            <a-input type="number" placeholder="Sponsor Account" v-model="form.sponsor_account">
            </a-input>
          </a-form-model-item>

          <a-form-item label="Sponsor Fee" ref="sponsor_fee">
            <a-input type="number" placeholder="Sponsor Fee" v-model="form.sponsor_fee">
            </a-input>
          </a-form-item>

          <a-form-model-item :wrapper-col="{ offset: 4 }">
            <a-button type="primary" html-type="submit" class="login-form-button" @click="save" :loading="submitting">
              Save
            </a-button>
          </a-form-model-item>
        </a-form-model>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import rules from './create-sponsor-config-rules'

export default {
  name: "create-sponsor-config",
  props: {
    sponsor_config: {
      type: Object,
      default: null,
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rules,
      item: {
        loading: false,
        configs: {}
      },
      submitting: false,
      preload: false,
      form: {
        biller_disbursement_account_id: '',
        sponsor_id: 0,
        sponsor_account: '',
        sponsor_fee: 0
      }
    }
  },
  created() {
    if (this.edit) {
      this.form.biller_disbursement_account_id = this.sponsor_config.biller_disbursement_account_id
      this.form.sponsor_id = this.sponsor_config.hash
      this.form.sponsor_account = this.sponsor_config.sponsor_account
      this.form.sponsor_fee = this.sponsor_config.sponsor_fee
      this.preload = true
    }
  },
  methods: {
    onSponsorChange(data) {
      this.form.sponsor_id = data.hash
    },
    onBillerAccountChange(data) {
      this.form.biller_disbursement_account_id = data.id
    },
    save() {
      this.$refs.formSponsorConfig.validate(valid => {
        if (valid) {
          if (this.edit) {
            this.editSponsorConfig()
          } else {
            this.createSponsorConfig()
          }
        }
      })
    },
    createSponsorConfig() {
      this.submitting = true
      this.$http.post(this.routeUri('hyperion.finances.sponsor-config.store'), this.form)
        .then(res => this.handleSuccessResponse(res.data))
        .catch(err => this.handleXhrError(err))
        .finally(() => (this.submitting = false))
    },
    editSponsorConfig() {
      this.submitting = true
      this.$http.put(this.routeUri('hyperion.finances.sponsor-config.update', {sponsor_config: this.sponsor_config.id}), this.form)
        .then(res => this.handleSuccessResponse(res.data))
        .catch(err => this.handleXhrError(err))
        .finally(() => (this.submitting = false))
    },
    handleSuccessResponse(data) {
      this.$notification.success({
        message: "Success",
        description: "You will be redirected in a few moment."
      })

      setTimeout(() => window.location.href = data.redirect, 3000)
    }
  }
}
</script>
